import { useEffect, useState } from "react";
import { HardHat, Link2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { HeroBanner } from "../components/HeroBanner";
import { ReportsTab } from "../components/teknisi/ReportsTab";
import { AttendanceTab } from "../components/teknisi/AttendanceTab";
import { TechTasksTab } from "../components/teknisi/TechTasksTab";
import { PerformanceTab } from "../components/teknisi/PerformanceTab";
import { TechniciansTab } from "../components/teknisi/TechniciansTab";
import { TechChatTab } from "../components/teknisi/TechChatTab";
import { TechMapTab } from "../components/teknisi/TechMapTab";
import { TechGroupTab } from "../components/teknisi/TechGroupTab";

const TABS = [["laporan", "Laporan Kerja"], ["absensi", "Absensi"], ["peta", "Peta Teknisi"], ["tugas", "Tugas Teknisi"], ["chat", "Chat Teknisi"], ["group", "Group Teknisi"], ["kinerja", "Kinerja"], ["teknisi", "Data Teknisi"]];

export default function LaporanTeknisi() {
  const { user: me } = useAuth();
  const [tab, setTab] = useState("laporan");
  const [techs, setTechs] = useState([]);
  const [unread, setUnread] = useState(0);
  const loadTechs = () => api.get("/teknisi/technicians").then((r) => setTechs(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { loadTechs(); const u = () => api.get("/teknisi/chat/unread").then((r) => setUnread(Object.values(r.data).reduce((a, b) => a + b, 0))).catch(() => {}); u(); const t = setInterval(u, 30000); return () => clearInterval(t); }, []);
  const portalUrl = `${window.location.origin}/teknisi`;
  return (
    <div className="space-y-4" data-testid="laporan-teknisi-page">
      <HeroBanner icon={HardHat} title="Laporan Kerja Teknisi" subtitle="Absensi selfie+GPS, laporan pekerjaan lapangan, tugas & kinerja teknisi · Jam kerja Senin–Sabtu 08.30–17.00" testid="teknisi-hero">
        <Button size="sm" className="h-9 bg-emerald-500 hover:bg-emerald-600 text-white shadow" onClick={() => { navigator.clipboard.writeText(portalUrl).then(() => toast.success("Link portal teknisi disalin")); }} data-testid="copy-portal-link"><Link2 className="w-4 h-4 mr-1.5" /> {portalUrl.replace(/^https?:\/\//, "")}</Button>
      </HeroBanner>
      <div className="flex flex-wrap gap-1" data-testid="teknisi-tabs">
        {TABS.map(([v, l]) => <button key={v} type="button" onClick={() => setTab(v)} className={`px-3 py-1 rounded-full text-xs border transition-colors ${tab === v ? "bg-[#F04E23] text-white border-[#F04E23]" : "border-border bg-card hover:bg-accent"}`} data-testid={`teknisi-tab-${v}`}>{l}{v === "chat" && unread > 0 && <span className="ml-1 px-1.5 rounded-full bg-rose-500 text-white text-[10px] font-bold" data-testid="teknisi-chat-badge">{unread}</span>}</button>)}
      </div>
      {tab === "laporan" && <ReportsTab techs={techs} me={me} />}
      {tab === "absensi" && <AttendanceTab techs={techs} />}
      {tab === "tugas" && <TechTasksTab techs={techs} />}
      {tab === "chat" && <TechChatTab techs={techs} />}
      {tab === "peta" && <TechMapTab />}
      {tab === "group" && <TechGroupTab />}
      {tab === "kinerja" && <PerformanceTab />}
      {tab === "teknisi" && <TechniciansTab techs={techs} me={me} onChange={loadTechs} />}
    </div>
  );
}
